enum RequestErrorCode {
  EmailAlreadyRegistered = 'EmailAlreadyRegistered',
  CannotMergeAccount = 'CannotMergeAccount',
  ProfileNotFound = 'ProfileNotFound',
  ProfileNotValid = 'Not Found',
}
export default RequestErrorCode;
